import { Injectable } from "@angular/core";
import { ModalName } from "../enums/modal-name";

@Injectable({ providedIn: "root" })
export class ModalService {
  openedModalName: ModalName | null = null;

  openModal(modalName: ModalName) {
    this.openedModalName = modalName;
  }

  closeModal() {
    this.openedModalName = null;
  }

  toggleModal(modalName: ModalName) {
    if (this.openedModalName === modalName) {
      this.openedModalName = null;
    } else {
      this.openedModalName = modalName;
    }
  }
}
